const DEPLOYMENT_REGIONS = {
  US: 'us',
  EU: 'eu',
} as const;

export const ENVIRONMENTS = {
  DEV: 'development',
  PROD: 'production',
} as const;

export const { DEV, PROD } = ENVIRONMENTS;

export const getDeployedRegion = () => {
  // matches `.eu.` or `.eu-` in the hostname
  if (window.location.hostname.match(/\.eu[.-]/)) {
    return DEPLOYMENT_REGIONS.EU;
  }
  return DEPLOYMENT_REGIONS.US;
};

/**
 * Returns The current node environment
 */
export function getEnvironment() {
  const { NODE_ENV } = process.env;
  return NODE_ENV?.toLowerCase() || '';
}

/**
 * Returns Whether the current environment is development.
 */
export function isDev() {
  return getEnvironment() === DEV;
}

/**
 * Returns Whether the current environment is production.
 */
export function isProd() {
  return getEnvironment() === PROD;
}

// environmental constants defined in webpack
export default {
  isDevEnv: ENV.IS_DEV,
  isProdEnv: ENV.IS_PROD,
  mode: ENV.MODE,
  publicPath: ENV.PUBLIC_PATH,
  version: ENV.VERSION,
};
